import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Button from '../Button/Button'

UploadButton.propTypes = {
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  onFileChange: PropTypes.func.isRequired,
}

export default function UploadButton(props) {
  const id = Math.random()
    .toString(16)
    .slice(-4)

  return (
    <React.Fragment>
      <HiddenInput
        disabled={props.disabled}
        id={props.id}
        onChange={props.onFileChange}
        type="file"
      />
      <LabelButton
        as="label"
        color={'#16a13b'}
        disabled={props.disabled}
        for={props.id}
      >
        {props.children}
      </LabelButton>
    </React.Fragment>
  )
}

const LabelButton = styled(Button)`
  input:focus + & {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }

  ${props =>
    props.disabled &&
    `background: #999;
    cursor: not-allowed;
    opacity: 0.65;`}
`

const HiddenInput = styled.input.attrs(props => ({
  type: 'file',
  accept: '.xls, .xlsx, .csv',
}))`
  opacity: 0;
  right: 0;
  top: 0;
  height: 0;
  width: 0;
`



// WEBPACK FOOTER //
// ./src/components/FileUpload/UploadButton.js